// Margem de lucro sobre o preço de venda: venda = custo / (1 - margem).
// A margem é sempre menor que 100%, senão a conta não fecha; este limite só protege a divisão.
const CALCULATION_LIMIT = 99.9999;

export function clampMargin(margin: number | null | undefined): number {
  return Math.min(Math.max(Number(margin) || 0, 0), CALCULATION_LIMIT);
}

export function salePriceFromMargin(cost: number, margin: number | null | undefined): number {
  const price = (Number(cost) || 0) / (1 - clampMargin(margin) / 100);
  return Math.round(price * 100) / 100;
}

// Margem (em %) que leva o custo ao preço de venda informado. Sem arredondar, para que
// salePriceFromMargin(custo, margem) devolva exatamente o mesmo preço.
export function marginFromSalePrice(cost: number, price: number): number {
  const salePrice = Number(price) || 0;
  if (salePrice <= 0) return 0;

  return ((salePrice - (Number(cost) || 0)) / salePrice) * 100;
}
